import SimpleLightbox from "simplelightbox";

jQuery(document).ready(function ($) {
    
    const windowHeight = jQuery(window).height();
    // Lightbox has to work only on mobile
    if (jQuery(window).width() < 576) {
        // Get all Article images (not in header-footer)
        let images = jQuery("#entry-content .ap_entry-content > .wp-block-image");

        images.each(function () {
            let theIMG = jQuery(this).find('img');
            // The img's figure can be wrapped in div OR can be alone
            let theImgParent = theIMG.parent();
            let theFigcaption = jQuery(this).find('figcaption');

            /**
             * The image can have figcaption its height is 45px (22.5+margins).
             * Need to add icon to hint user that image the possibility of enlargement.
             * To position ::before icon over image need to set it's bottom property based on existence of figcaption
             */
            if (theFigcaption.length) {
                theImgParent.css('--ap-before-bottom', '65px');
            }else{
                theImgParent.css('--ap-before-bottom', '20px');
            }

            // Instantiate SimpleLightbox
            let lightbox = new SimpleLightbox(theIMG, {
                sourceAttr: 'src',
                nav: false,
                preloading: false,
                className: apriorit_lightbox_options.class_name,
                scaleImageToRatio: true,
                widthRatio: apriorit_lightbox_options.width_ratio,
                heightRatio: apriorit_lightbox_options.height_ratio,
                disableScroll: true,
                swipeClose: false,
                swipeTolerance: 577
            });

            // On figure's ::before (enlarge icon) need to trigger the same behavior as click on img
            theImgParent.click(function (event) {
                if (event.target !== theIMG[0]) {
                    theIMG.click();
                }
            });

            // Add event listener for 'show' event
            lightbox.on('show.simplelightbox', function () {
                // Disable scrolling on the body element
                document.body.style.overflow = 'hidden';
            });

            // Add event listener for 'closed' event
            lightbox.on('close.simplelightbox', function () {
                // Enable scrolling on the body element
                document.body.style.overflow = 'auto';
            });
        });

        // need to show "icon to hint user the possibility of enlargement" after img is going to be shown 
        jQuery(window).on("scroll", function () {
            images.each(function () {
                let theIMG = jQuery(this).find('img');
                // The img's figure can be wrapped in div OR can be alone
                let theImgParent = theIMG.parent();

                // Check if element is in viewport
                if (jQuery(this).offset().top < jQuery(window).scrollTop() + windowHeight) {
                    theImgParent.addClass('show-lightbox-icon');
                }
            });
        });
    }
});